export const jobs = [
  {
    // type: "developer".工程师 2.产品 3.商务
    id: 1,
    type: "product",
    city: "beijing",
    title: "joinus.jobs.job1.title",
    salary: "joinus.jobs.job1.salary",
    info: "joinus.jobs.job1.experience",
    time: "2021-10-28",
    desc: [
      "joinus.jobs.job1.description.item1",
      "joinus.jobs.job1.description.item2",
      "joinus.jobs.job1.description.item3",
      "joinus.jobs.job1.description.item4",
      "joinus.jobs.job1.description.item5",
    ],
    skills: [
      "joinus.jobs.job1.skills.item1",
      "joinus.jobs.job1.skills.item2",
      "joinus.jobs.job1.skills.item3",
      "joinus.jobs.job1.skills.item4",
      "joinus.jobs.job1.skills.item5",
      "joinus.jobs.job1.skills.item6",
      "joinus.jobs.job1.skills.item7",
    ],
  },
  {
    id: 2,
    type: "product",
    city: "beijing",
    title: "joinus.jobs.job2.title",
    salary: "joinus.jobs.job2.salary",
    info: "joinus.jobs.job2.experience",
    time: "2021-10-28",
    desc: [
      "joinus.jobs.job2.description.item1",
      "joinus.jobs.job2.description.item2",
    ],
    skills: [
      "joinus.jobs.job2.skills.item1",
      "joinus.jobs.job2.skills.item2",
      "joinus.jobs.job2.skills.item3",
      "joinus.jobs.job2.skills.item4",
      "joinus.jobs.job2.skills.item5",
      "joinus.jobs.job2.skills.item6",
      "joinus.jobs.job2.skills.item7",
      "joinus.jobs.job2.skills.item8",
      "joinus.jobs.job2.skills.item9",
      "joinus.jobs.job2.skills.item10",
    ],
  },
  {
    id: 3,
    type: "product",
    city: "beijing",
    title: "joinus.jobs.job3.title",
    salary: "joinus.jobs.job3.salary",
    info: "joinus.jobs.job3.experience",
    time: "2021-10-28",
    desc: [
      "joinus.jobs.job3.description.item1",
      "joinus.jobs.job3.description.item2",
      "joinus.jobs.job3.description.item3",
      "joinus.jobs.job3.description.item4",
      "joinus.jobs.job3.description.item5",
    ],
    skills: [
      "joinus.jobs.job3.skills.item1",
      "joinus.jobs.job3.skills.item2",
      "joinus.jobs.job3.skills.item3",
      "joinus.jobs.job3.skills.item4",
      "joinus.jobs.job3.skills.item5",
      "joinus.jobs.job3.skills.item6",
      "joinus.jobs.job3.skills.item7",
      "joinus.jobs.job3.skills.item8",
    ],
  },
  {
    id: 4,
    type: "other",
    city: "beijing",
    title: "joinus.jobs.job4.title",
    salary: "joinus.jobs.job4.salary",
    info: "joinus.jobs.job4.experience",
    time: "2021-10-28",
    desc: [
      "joinus.jobs.job4.description.item1",
      "joinus.jobs.job4.description.item2",
      "joinus.jobs.job4.description.item3",
      "joinus.jobs.job4.description.item4",
      "joinus.jobs.job4.description.item5",
    ],
    skills: [
      "joinus.jobs.job4.skills.item1",
      "joinus.jobs.job4.skills.item2",
      "joinus.jobs.job4.skills.item3",
      "joinus.jobs.job4.skills.item4",
      "joinus.jobs.job4.skills.item5",
      "joinus.jobs.job4.skills.item6",
    ],
  },
  {
    id: 5,
    type: "business",
    city: "beijing",
    title: "joinus.jobs.job5.title",
    salary: "joinus.jobs.job5.salary",
    info: "joinus.jobs.job5.experience",
    time: "2021-10-28",
    desc: [
      "joinus.jobs.job5.description.item1",
      "joinus.jobs.job5.description.item2",
      "joinus.jobs.job5.description.item3",
      "joinus.jobs.job5.description.item4",
      "joinus.jobs.job5.description.item5",
    ],
    skills: [
      "joinus.jobs.job5.skills.item1",
      "joinus.jobs.job5.skills.item2",
      "joinus.jobs.job5.skills.item3",
      "joinus.jobs.job5.skills.item4",
      "joinus.jobs.job5.skills.item5",
      "joinus.jobs.job5.skills.item6",
    ],
  },
  {
    id: 6,
    type: "business",
    city: ["beijing", "shanghai", "shenzhen"],
    title: "joinus.jobs.job6.title",
    salary: "joinus.jobs.job6.salary",
    info: "joinus.jobs.job6.experience",
    time: "2021-10-28",
    desc: [
      "joinus.jobs.job6.description.item1",
      "joinus.jobs.job6.description.item2",
      "joinus.jobs.job6.description.item3",
      "joinus.jobs.job6.description.item4",
    ],
    skills: [
      "joinus.jobs.job6.skills.item1",
      "joinus.jobs.job6.skills.item2",
      "joinus.jobs.job6.skills.item3",
      "joinus.jobs.job6.skills.item4",
    ],
  },
  {
    id: 7,
    type: "business",
    city: ["beijing", "shanghai", "shenzhen"],
    title: "joinus.jobs.job7.title",
    salary: "joinus.jobs.job7.salary",
    info: "joinus.jobs.job7.experience",
    time: "2021-10-28",
    desc: [
      "joinus.jobs.job7.description.item1",
      "joinus.jobs.job7.description.item2",
      "joinus.jobs.job7.description.item3",
      "joinus.jobs.job7.description.item4",
    ],
    skills: [
      "joinus.jobs.job7.skills.item1",
      "joinus.jobs.job7.skills.item2",
      "joinus.jobs.job7.skills.item3",
    ],
  },
  {
    id: 8,
    type: "product",
    city: "beijing",
    title: "joinus.jobs.job8.title",
    salary: "joinus.jobs.job8.salary",
    info: "joinus.jobs.job8.experience",
    time: "2021-10-28",
    desc: [
      "joinus.jobs.job8.description.item1",
      "joinus.jobs.job8.description.item2",
      "joinus.jobs.job8.description.item3",
      "joinus.jobs.job8.description.item4",
    ],
    skills: [
      "joinus.jobs.job8.skills.item1",
      "joinus.jobs.job8.skills.item2",
      "joinus.jobs.job8.skills.item3",
      "joinus.jobs.job8.skills.item4",
      "joinus.jobs.job8.skills.item5",
      "joinus.jobs.job8.skills.item6",
      "joinus.jobs.job8.skills.item7",
    ],
  },

  {
    id: 9,
    type: "product",
    city: "beijing",
    title: "joinus.jobs.job9.title",
    salary: "joinus.jobs.job9.salary",
    info: "joinus.jobs.job9.experience",
    time: "2021-10-28",
    desc: [
      "joinus.jobs.job9.description.item1",
      "joinus.jobs.job9.description.item2",
      "joinus.jobs.job9.description.item3",
      "joinus.jobs.job9.description.item4",
      "joinus.jobs.job9.description.item5",
      "joinus.jobs.job9.description.item6",
      "joinus.jobs.job9.description.item7",
    ],
    skills: [
      "joinus.jobs.job9.skills.item1",
      "joinus.jobs.job9.skills.item2",
      "joinus.jobs.job9.skills.item3",
      "joinus.jobs.job9.skills.item4",
      "joinus.jobs.job9.skills.item5",
      "joinus.jobs.job9.skills.item6",
      "joinus.jobs.job9.skills.item7",
      "joinus.jobs.job9.skills.item8",
    ],
  },
  {
    id: 10,
    type: "product",
    city: "beijing",
    title: "joinus.jobs.job10.title",
    salary: "joinus.jobs.job10.salary",
    info: "joinus.jobs.job10.experience",
    time: "2021-10-28",
    desc: [
      "joinus.jobs.job10.description.item1",
      "joinus.jobs.job10.description.item2",
      "joinus.jobs.job10.description.item3",
      "joinus.jobs.job10.description.item4",
      "joinus.jobs.job10.description.item5",
      "joinus.jobs.job10.description.item6",
    ],
    skills: [
      "joinus.jobs.job10.skills.item1",
      "joinus.jobs.job10.skills.item2",
      "joinus.jobs.job10.skills.item3",
      "joinus.jobs.job10.skills.item4",
      "joinus.jobs.job10.skills.item5",
      "joinus.jobs.job10.skills.item6",
      "joinus.jobs.job10.skills.item7",
    ],
  },
  {
    id: 11,
    type: "other",
    city: "beijing",
    title: "joinus.jobs.job11.title",
    salary: "joinus.jobs.job11.salary",
    info: "joinus.jobs.job11.experience",
    time: "2021-10-28",
    desc: [
      "joinus.jobs.job11.description.item1",
      "joinus.jobs.job11.description.item2",
      "joinus.jobs.job11.description.item3",
      "joinus.jobs.job11.description.item4",
      "joinus.jobs.job11.description.item5",
      "joinus.jobs.job11.description.item6",
      "joinus.jobs.job11.description.item7",
    ],
    skills: [
      "joinus.jobs.job11.skills.item1",
      "joinus.jobs.job11.skills.item2",
      "joinus.jobs.job11.skills.item3",
      "joinus.jobs.job11.skills.item4",
      "joinus.jobs.job11.skills.item5",
    ],
  },
  {
    id: 12,
    type: "other",
    city: "beijing",
    title: "joinus.jobs.job12.title",
    salary: "joinus.jobs.job12.salary",
    info: "joinus.jobs.job12.experience",
    time: "2021-10-28",
    desc: [
      "joinus.jobs.job12.description.item1",
      "joinus.jobs.job12.description.item2",
      "joinus.jobs.job12.description.item3",
      "joinus.jobs.job12.description.item4",
      "joinus.jobs.job12.description.item5",
    ],
    skills: [
      "joinus.jobs.job12.skills.item1",
      "joinus.jobs.job12.skills.item2",
      "joinus.jobs.job12.skills.item3",
      "joinus.jobs.job12.skills.item4",
    ],
  },
  {
    id: 13,
    type: "product",
    city: "beijing",
    title: "joinus.jobs.job13.title",
    salary: "joinus.jobs.job13.salary",
    info: "joinus.jobs.job13.experience",
    time: "2021-10-28",
    desc: [
      "joinus.jobs.job13.description.item1",
      "joinus.jobs.job13.description.item2",
      "joinus.jobs.job13.description.item3",
      "joinus.jobs.job13.description.item4",
    ],
    skills: [
      "joinus.jobs.job13.skills.item1",
      "joinus.jobs.job13.skills.item2",
      "joinus.jobs.job13.skills.item3",
      "joinus.jobs.job13.skills.item4",
      "joinus.jobs.job13.skills.item5",
      "joinus.jobs.job13.skills.item6",
    ],
  },
  {
    id: 14,
    type: "product",
    city: "beijing",
    title: "joinus.jobs.job14.title",
    salary: "joinus.jobs.job14.salary",
    info: "joinus.jobs.job14.experience",
    time: "2021-10-28",
    desc: [
      "joinus.jobs.job14.description.item1",
      "joinus.jobs.job14.description.item2",
      "joinus.jobs.job14.description.item3",
      "joinus.jobs.job14.description.item4",
      "joinus.jobs.job14.description.item5",
      "joinus.jobs.job14.description.item6",
      "joinus.jobs.job14.description.item7",
    ],
    skills: [
      "joinus.jobs.job14.skills.item1",
      "joinus.jobs.job14.skills.item2",
      "joinus.jobs.job14.skills.item3",
      "joinus.jobs.job14.skills.item4",
      "joinus.jobs.job14.skills.item5",
      "joinus.jobs.job14.skills.item6",
    ],
  },
  {
    id: 15,
    type: "product",
    city: "beijing",
    title: "joinus.jobs.job15.title",
    salary: "joinus.jobs.job15.salary",
    info: "joinus.jobs.job15.experience",
    time: "2021-10-28",
    desc: [
      "joinus.jobs.job15.description.item1",
      "joinus.jobs.job15.description.item2",
      "joinus.jobs.job15.description.item3",
      "joinus.jobs.job15.description.item4",
    ],
    skills: [
      "joinus.jobs.job15.skills.item1",
      "joinus.jobs.job15.skills.item2",
      "joinus.jobs.job15.skills.item3",
    ],
  },
  {
    id: 16,
    type: "business",
    city: "beijing",
    title: "joinus.jobs.job16.title",
    salary: "joinus.jobs.job16.salary",
    info: "joinus.jobs.job16.experience",
    time: "2021-10-28",
    desc: [
      "joinus.jobs.job16.description.item1",
      "joinus.jobs.job16.description.item2",
      "joinus.jobs.job16.description.item3",
      "joinus.jobs.job16.description.item4",
      "joinus.jobs.job16.description.item5",
      "joinus.jobs.job16.description.item6",
    ],
    skills: [
      "joinus.jobs.job16.skills.item1",
      "joinus.jobs.job16.skills.item2",
      "joinus.jobs.job16.skills.item3",
      "joinus.jobs.job16.skills.item4",
      "joinus.jobs.job16.skills.item5",
      "joinus.jobs.job16.skills.item6",
    ],
  },
  {
    id: 17,
    type: "business",
    city: "beijing",
    title: "joinus.jobs.job17.title",
    salary: "joinus.jobs.job17.salary",
    info: "joinus.jobs.job17.experience",
    time: "2021-10-28",
    desc: [
      "joinus.jobs.job17.description.item1",
      "joinus.jobs.job17.description.item2",
      "joinus.jobs.job17.description.item3",
      "joinus.jobs.job17.description.item4",
    ],
    skills: [
      "joinus.jobs.job17.skills.item1",
      "joinus.jobs.job17.skills.item2",
      "joinus.jobs.job17.skills.item3",
      "joinus.jobs.job17.skills.item4",
      "joinus.jobs.job17.skills.item5",
      "joinus.jobs.job17.skills.item6",
    ],
  },
  {
    id: 18,
    type: "business",
    city: "beijing",
    title: "joinus.jobs.job18.title",
    salary: "joinus.jobs.job18.salary",
    info: "joinus.jobs.job18.experience",
    time: "2021-10-28",
    desc: [
      "joinus.jobs.job18.description.item1",
      "joinus.jobs.job18.description.item2",
      "joinus.jobs.job18.description.item3",
    ],
    skills: [
      "joinus.jobs.job18.skills.item1",
      "joinus.jobs.job18.skills.item2",
      "joinus.jobs.job18.skills.item3",
      "joinus.jobs.job18.skills.item4",
      "joinus.jobs.job18.skills.item5",
      "joinus.jobs.job18.skills.item6",
    ],
  },
  {
    id: 19,
    type: "business",
    city: ["beijing", "shanghai", "shenzhen"],
    title: "joinus.jobs.job19.title",
    salary: "joinus.jobs.job19.salary",
    info: "joinus.jobs.job19.experience",
    time: "2021-10-28",
    desc: [
      "joinus.jobs.job19.description.item1",
      "joinus.jobs.job19.description.item2",
      "joinus.jobs.job19.description.item3",
      "joinus.jobs.job19.description.item4",
      "joinus.jobs.job19.description.item5",
      "joinus.jobs.job19.description.item6",
    ],
    skills: [
      "joinus.jobs.job19.skills.item1",
      "joinus.jobs.job19.skills.item2",
      "joinus.jobs.job19.skills.item3",
      "joinus.jobs.job19.skills.item4",
      "joinus.jobs.job19.skills.item5",
      "joinus.jobs.job19.skills.item6",
    ],
  },
];
